import { useState } from "react";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useImpersonateUserMutation } from "../impersonation/impersonationApiSlice";
import { useImpersonationHandoff } from "../impersonation/useImpersonationHandoff";
import { DemoUserViewModel } from "./demoApiSlice";

interface DemoUsersTableProps {
	users: DemoUserViewModel[];
}

export default function DemoUsersTable(props: DemoUsersTableProps) {
	const [signingInUserId, setSigningInUserId] = useState<number | null>(null);

	const [impersonateUser] = useImpersonateUserMutation();
	const { handleImpersonationResult, showImpersonationError } = useImpersonationHandoff();

	const impersonateErrorMessage = "There was an error signing in as this user.";

	const handleImpersonate = (userId: number) => {
		setSigningInUserId(userId);
		impersonateUser(userId)
			.unwrap()
			.then((result) => {
				// On success the app navigates away; otherwise re-enable the button.
				if (!handleImpersonationResult(result, impersonateErrorMessage)) {
					setSigningInUserId(null);
				}
			})
			.catch(() => {
				showImpersonationError(undefined, impersonateErrorMessage);
				setSigningInUserId(null);
			});
	};

	const actionBodyTemplate = (row: DemoUserViewModel) => {
		return (
			<button
				id={`impersonate-${row.id}`}
				className="btn btn-action !px-2"
				disabled={signingInUserId === row.id}
				onClick={() => handleImpersonate(row.id)}>
				{signingInUserId === row.id ? "Signing In…" : "Sign In"}
			</button>
		);
	};

	return (
		<DataTable
			value={props.users}
			dataKey="id"
			stripedRows
			emptyMessage="No demo users found"
			className="tbl tbl-data tbl-datatable min-w-[40rem] cursor-default"
			style={{ paddingTop: "16px" }}>
			<Column header="Role" field="role" headerClassName="!px-2" className="!px-2"></Column>
			<Column
				header="Username"
				field="username"
				headerClassName="!px-2"
				className="!px-2"></Column>
			<Column
				body={actionBodyTemplate}
				headerClassName="!px-2 w-24"
				className="!px-2"></Column>
		</DataTable>
	);
}
